import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { path } from 'ramda'

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/list',
    name: 'List',
    component: () => import('@/views/claimList.vue'),
    meta: { title: '案件列表' },
  },
  {
    path: '/listDetail',
    name: 'ListDetail',
    component: () => import('@/views/listDetail.vue'),
    meta: { title: '列表详情' },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home.vue'),
    meta: { title: '首页' },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home.vue'),
    meta: { title: '首页' },
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/index.vue'),
    meta: { title: '图像自动分类' },
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import('@/views/manual.vue'),
    meta: { title: '图像手动分类' },
  },
  {
    path: '/classify',
    name: 'Classify',
    component: () => import('@/views/classify.vue'),
    meta: { title: '图像分类' },
  },
]

const routesMobile = []

const router = createRouter({
  history: import.meta.env.VITE_APP_BASE_ROUTER_MODE === 'hash' ? createWebHashHistory() : createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.onlytitle) {
    document.title = to.meta.title
  } else {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = '图像分类'
    }
  }

  next()

  // if (userStore.getToken() && userStore.getTokenName() === 'Authorization') {
  //   if (!to.path || to.path === '/') {
  //     return next({ path: '/mainPage' })
  //   }

  //   // 已登录
  //   if (to.path === '/login') {
  //     // 已登录情况下，即使去login页面，也会重定向到首页
  //     next({ path: '/layout' })
  //   } else {
  //     next()
  //   }
  // } else {
  //   // 设置白名单
  //   const whiteList = ['/loginRelay', '/login', '/openWx', '/lossInfoView', '/imageAiResultView']
  //   // 未登录
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // }
})

export default router
